'use client'

import { Basket, CartInfoSchema, CartPageInfoScript } from '@/screens/Cart'

export function CartClient() {
	return (
		<>
			<CartInfoSchema />
			<CartPageInfoScript />
			<Basket isRedirectedFromRegion={false} />
		</>
	)
}
